import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Cards, numbers, Players, symbols } from '../../poker.service';

@Component({
  selector: 'app-poker-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {

  constructor() { }
  @Input()
  card:Cards;
  type:symbols;
  no:number;
  get text():string{
    return this.card?.isOpen? this.card.text:'🂠';
  }
  get color():'red'|'black'{
    return this.card.isOpen&&( this.type=='♡'|| this.type=='♢'||this.no==-1)?'red':'black'
  }
  @Output()
  cardClick:EventEmitter<Cards> = new EventEmitter()
  @Output()
  cardRightClick:EventEmitter<Cards> = new EventEmitter()
  ngOnInit(): void {
    this.card.comp = this;
    this.type = this.card.type;
    this.no = this.card.no;
    
  }
  onClick(){
    this.cardClick.emit(this.card);
  }
  onView(evt:Event){
    evt.preventDefault();
    if(!this.card.isOpen){
      this.card.isOpen = true;
      setTimeout(() => {
        this.card.isOpen = false;
      }, 1000);
    }
    
    this.cardRightClick.emit(this.card);
  }
  onHover(){

  }
}